import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../reducer/authReducer";
import userAddressReducer from "../reducer/userAddressReducer";
import userMainTurkishWebsites from "../reducer/turkishWebsitesMainReducer";
import websitesEuropeanReducer from "../reducer/europaWebsitesMainReducer";
import shopCartReducer from "../reducer/shopCartReducer";
import notificatioReducer from "../reducer/notificationReducer";
import shipmentCostReducer from "../reducer/shipmentCostReducer";
import contactReducer from "../reducer/contactUsReducer";
import currenciesReducer from "../reducer/currancyReducer";
import areaReducer from "../reducer/areaReducer";
import brandsReducer from "../reducer/brandReducer";
import subCategoryReducer from "../reducer/subCategoryReducer";
import categoryReducer from "../reducer/categoryReducer";
import ShoppingChoiceReducer from "../reducer/ShoppingChoiceReducer";
import servicesReducer from "../reducer/servicesReducer";
import storesReducer from "../reducer/storesReducer";
import subscribeReducer from "../reducer/subCategoryReducer";
import cartReducer from "../reducer/cartReducer";
import productReducer from "../reducer/productReducer";
import languageReducer from "../reducer/languageReducer";
import userReducer from "../reducer/userReducer";
import analyticsDataReducer from "../reducer/analyticsDataReducer";
import feedbackReducer from "../reducer/feedbackReducer";
import couponReducer from "../reducer/couponsReducer";
import couponSettingReducer from "../reducer/couponSettingReducer";
import commentReducer from "../reducer/commentReducer";
import shopBrandReducer from "../reducer/shopBrandReducer";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    userAddress: userAddressReducer,
    websites: userMainTurkishWebsites,
    websitesEuropean: websitesEuropeanReducer,
    shopCart: shopCartReducer,
    notifications: notificatioReducer,
    shipmentCost: shipmentCostReducer,
    contact: contactReducer,
    currencies: currenciesReducer,
    areas: areaReducer,
    brands: brandsReducer,
    subCategories: subCategoryReducer,
    categories: categoryReducer,
    shopping: ShoppingChoiceReducer,
    ourServices: servicesReducer,
    stores: storesReducer,
    subscribe: subscribeReducer,
    carts: cartReducer,
    products: productReducer,
    language: languageReducer,
    users: userReducer,
    analytics: analyticsDataReducer,
    feedback: feedbackReducer,
    coupon: couponReducer,
    couponSetting: couponSettingReducer,
    comments: commentReducer,
    shopBrand: shopBrandReducer,
  },
});
